export default function setSearchTerm(searchTerm, { refresh = false, debounce = 0 } = {}) {
	this._setState({ searchTerm })

	if (refresh) {
		this.debounceManager.runWithDebounce(
			debounce,
			'_updateSearchResults',
			this._updateSearchResults,
			{
				pageNumber: 1,
				facets: [],
			},
		)
	}
}
